import MovementsList from './MovementsList'

export default {
  list: MovementsList,
}
